import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import axiosRequest from "./axiosRequest";

// Fetching a list of projects
export const useGetProjectTags = () => {
  return useQuery({
    queryKey: ["get-tags"],
    queryFn: async () => {
      const response = await axiosRequest("public/get-all-tags", "GET");
      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to fetch tags");
      }
      return response.data.data;
    },
    onError: (error) => {
    },
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useGetProjects = (pageSize, searchTerm, order, orderBy, tags) => {
  return useInfiniteQuery({
    queryKey: [
      "get-portfolio-projects",
      pageSize,
      searchTerm,
      order,
      orderBy,
      tags,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const formData = new FormData();
      formData.append("page", pageParam);
      formData.append("limit", pageSize);
      formData.append("search", searchTerm);
      formData.append("sort_by", orderBy);
      formData.append("order_by", order);
      formData.append("tags", tags);

      const response = await axiosRequest(
        "public/get-project-information",
        "POST",
        formData,
        "multipart/form-data;"
      );

      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to fetch projects");
      }

      return {
        data: response.data.data.projectData,
        nextPage: response.data.data.projectData.length ? pageParam + 1 : null,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 15,
  });
};

// Fetching a single project's details
export const useGetProjectBySlug = (slug) => {
  return useQuery({
    queryKey: ["get-portfolio-project", slug],
    queryFn: async () => {
      const formData = new FormData();
      formData.append("slug", slug);
      const response = await axiosRequest(
        "public/get-project-information",
        "POST",
        formData,
        "multipart/form-data;"
      );
      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to fetch project");
      }
      return response.data.data;
    },
    onError: (error) => {
    },
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 15,
    enabled: !!slug,
  });
};
